import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgMinus = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M32 13.818v4.364c0 1.212-.97 2.182-2.182 2.182H2.182A2.173 2.173 0 0 1 0 18.182v-4.364c0-1.212.97-2.182 2.182-2.182h27.636c1.212 0 2.182.97 2.182 2.182z" /></svg>;
export default SvgMinus;